import { render, staticRenderFns } from "./frame-item.vue?vue&type=template&id=5783ac70&scoped=true&"
import script from "./frame-item.vue?vue&type=script&lang=js&"
export * from "./frame-item.vue?vue&type=script&lang=js&"
import style0 from "./frame-item.vue?vue&type=style&index=0&id=5783ac70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5783ac70",
  null
  
)

export default component.exports